/* ==========================================================================
   ENSAC — automatic alt text, site-wide
   ==========================================================================
   For any <img> left without alt text, this fills it in from the image's
   file name (e.g. "hand-bag_classic-tote.jpg" -> "Hand bag classic tote").
   An alt you've written yourself is never touched.

   To mark an image as decorative on purpose (so it stays silent for screen
   readers, which is correct for backgrounds, dividers, etc.), add any one of:
     - aria-hidden="true"
     - role="presentation" or role="none"
     - class="no-autoalt"          <img class="no-autoalt" ... >
     - data-no-autoalt             <img data-no-autoalt ... >
   ========================================================================== */
(function () {
  'use strict';

  function deriveAltFromSrc(src) {
    try {
      var name = (src.split('/').pop() || '').split('?')[0];
      try { name = decodeURIComponent(name); } catch (e) { /* leave as-is if it isn't valid encoding */ }
      name = name.replace(/\.[a-zA-Z0-9]+$/, '');
      name = name.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1);
    } catch (e) {
      return '';
    }
  }

  function isMarkedDecorative(img) {
    if (img.getAttribute('aria-hidden') === 'true') return true;
    var role = img.getAttribute('role');
    if (role === 'presentation' || role === 'none') return true;
    if (img.hasAttribute('data-no-autoalt')) return true;
    if (img.classList && img.classList.contains('no-autoalt')) return true;
    return false;
  }

  function bestSrc(img) {
    return (
      img.currentSrc ||
      img.getAttribute('src') ||
      img.getAttribute('data-src') ||
      (img.getAttribute('srcset') || '').split(',')[0].trim().split(' ')[0] ||
      ''
    );
  }

  function processImage(img) {
    if (img.__autoAltDone) return;
    if (isMarkedDecorative(img)) { img.__autoAltDone = true; return; }
    var alt = img.getAttribute('alt');
    if (alt !== null && alt.trim() !== '') { img.__autoAltDone = true; return; }
    var src = bestSrc(img);
    if (!src) return; // image not loaded yet - try again on the next pass
    var derived = deriveAltFromSrc(src);
    if (derived) img.setAttribute('alt', derived);
    img.__autoAltDone = true;
  }

  function scan(root) {
    var imgs = (root || document).querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) processImage(imgs[i]);
  }

  function init() {
    scan(document);

    // Apps, sliders, quick-view modals and infinite scroll add images later.
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.tagName === 'IMG') processImage(node);
            else if (node.querySelectorAll) scan(node);
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Late-loading images (lazy-load, slow third-party widgets) that were
    // present but had no resolved src on the first pass.
    setTimeout(function () { scan(document); }, 1500);
    setTimeout(function () { scan(document); }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor re-renders sections live.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
